import { template as template_a5eccb3ade3e4bb48a915edc3b8452d5 } from "@ember/template-compiler";
import Component from '@glimmer/component';
/**
  Renders a `<tfoot>` element and yields the row component.
  ```hbs
  <table.tfoot as |foot|>
    <foot.row as |row|>
      <row.cell>
        Footer content
      </row.cell>
    </foot.row>
  </table.tfoot>
  ```

  @class TTFoot
  @yield {object} footer
  @yield {Component} footer.row
*/ import { hash } from '@ember/helper';
import TFootRow from './tfoot/row.gjs';
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class TFoot extends Component {
    static{
        template_a5eccb3ade3e4bb48a915edc3b8452d5(`
    <tfoot class={{@theme.tfoot}} ...attributes>
      {{yield (hash row=(component TFootRow columns=@columns theme=@theme parent=@parent))}}
    </tfoot>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3Rmb290LmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5cbi8qKlxuICBSZW5kZXJzIGEgYDx0Zm9vdD5gIGVsZW1lbnQgYW5kIHlpZWxkcyB0aGUgcm93IGNvbXBvbmVudC5cbiAgYGBgaGJzXG4gIDx0YWJsZS50Zm9vdCBhcyB8Zm9vdHw-XG4gICAgPGZvb3Qucm93IGFzIHxyb3d8PlxuICAgICAgPHJvdy5jZWxsPlxuICAgICAgICBGb290ZXIgY29udGVudFxuICAgICAgPC9yb3cuY2VsbD5cbiAgICA8L2Zvb3Qucm93PlxuICA8L3RhYmxlLnRmb290PlxuICBgYGBcblxuICBAY2xhc3MgVFRGb290XG4gIEB5aWVsZCB7b2JqZWN0fSBmb290ZXJcbiAgQHlpZWxkIHtDb21wb25lbnR9IGZvb3Rlci5yb3dcbiovXG5pbXBvcnQgeyBoYXNoIH0gZnJvbSAnQGVtYmVyL2hlbHBlcic7XG5pbXBvcnQgVEZvb3RSb3cgZnJvbSAnLi90Zm9vdC9yb3cuZ2pzJztcblxuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIGVtYmVyL25vLWVtcHR5LWdsaW1tZXItY29tcG9uZW50LWNsYXNzZXNcbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFRGb290IGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgPHRlbXBsYXRlPlxuICAgIDx0Zm9vdCBjbGFzcz17e0B0aGVtZS50Zm9vdH19IC4uLmF0dHJpYnV0ZXM-XG4gICAgICB7e3lpZWxkIChoYXNoIHJvdz0oY29tcG9uZW50IFRGb290Um93IGNvbHVtbnM9QGNvbHVtbnMgdGhlbWU9QHRoZW1lIHBhcmVudD1AcGFyZW50KSl9fVxuICAgIDwvdGZvb3Q-XG4gIDwvdGVtcGxhdGU-XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFFM0M7Ozs7Ozs7Ozs7Ozs7OztBQWVBLEdBQ0EsU0FBUyxJQUFJLFFBQVEsZ0JBQWdCO0FBQ3JDLE9BQU8sY0FBYyxrQkFBa0I7QUFFdkMsb0VBQW9FO0FBQ3BFLGVBQWUsTUFBTSxjQUFjO0lBQ2pDLE1BQUE7UUFBQSwwQ0FBVSxDQUFBOzs7O0VBSVYsQ0FBQSxFQUFBO1lBQUEsV0FBQSxJQUFXO1lBQVg7Z0JBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO1lBQUQ7UUFBQTtJQUFBLENBSkE7QUFLWiJ9